//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState, useEffect } from 'react';

export function useList(
    getList = null, 
    listName,
    bypassCache = false,
) {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;
        //
        // Support function to fetch the list and cache for future use
        //
        async function fetchData() {
            if (typeof getList !== 'function') {
                //console.error(`useCachedList - no getList function provided, cannot load the ${listName} list to cache`);
                setLoading(false);
                setError(`useCachedList - no getList function provided, cannot load the ${listName} list to cache`)
                return;
            }

            try {
                // Fetch the list 
                const data = await getList(listName, bypassCache);

                if (isMounted) {
                    // use it locally in this control
                    setList(data);
                    setLoading(false);
                }

            } catch (error) {
                console.log(error)
                // on failures...
                if (isMounted) {
                    setLoading(false);
                    setError(error.message);
                }
            }
        }

        fetchData();

        return () => {
            isMounted = false;
        }

    }, [getList, listName, bypassCache]);


    return {
        error,
        loading, 
        list, 
    };

}

